import React from 'react';

// deployment test

import {Grid, List, ListItem, Typography, Divider} from '@mui/material';

export default function ItemHeader() {
  return (
		<List>
			<ListItem key="header">
				<Grid container justify="center" spacing={4}>
					<Grid sx={{display: 'flex', alignItems: {xs: 'left', xl: 'center'}, justifyContent:'left'}} item xs={5} sm={5} md={3} lg={3} xl={2}>
						<Typography align="center" color="primary" variant="h5" sx={{ fontSize: {xs: '16px', sm: '24px'}, fontWeight: '800'}} >Otsikko</Typography>
					</Grid>
					<Grid sx={{display: 'flex', alignItems: {xs: 'left', xl: 'center'}, justifyContent: 'left'}} item xs={3} sm={3} md={2.25} lg={1.75} xl={1.25}>
						<Typography color="primary" variant="h5" sx={{ fontSize: {xs: '16px', sm: '24px'}, fontWeight: '800'}}>Tyyppi</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', md: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} md={2.25} lg={1.75} xl={1.25}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Julkaisija</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', md: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} md={1.5} lg={1} xl={1}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Vuosi</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', lg: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item md={0} lg={1.5} xl={1.25}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Tekijä</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', lg: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item md={0} lg={1.5} xl={1.25}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Teema</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', xl: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} xl={1.5}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Kohderyhmä</Typography>
					</Grid>
					<Grid sx={{display: {xs: 'none', xl: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} xl={1.25}>
						<Typography color="primary" variant="h5" style={{fontWeight: '800'}}>Oppiaine</Typography>
					</Grid>
					<Grid sx={{display: 'flex', alignItems: {xs: 'left', xl: 'center'}, justifyContent: 'left'}} item xs={3} sm={4} md={2} lg={1.5} xl={1.25}>
						<Typography color="primary" variant="h5" sx={{ fontSize: {xs: '16px', sm: '24px'}, fontWeight: '800'}}>Saatavuus</Typography>
					</Grid>
				</Grid>
			</ListItem>
			<Divider variant="fullWidth" component="li" sx={{marginTop: '30px'}} />
			</List>
  );
}